import { useMutation, useQuery } from '@/hooks'
import { useQueryClient } from '@tanstack/react-query'

export type PicklistKind = 'durian_type' | 'grade' | 'strap_band' | 'expense_type'

export type PicklistEntry = {
  id: string
  kind: PicklistKind
  label: string
  sort_order: number
  is_active: boolean
  created_at: string
  updated_at: string
}

type PicklistListResponse = { data: PicklistEntry[] }

export const usePicklistByKind = (kind: PicklistKind) => {
  return useQuery<PicklistListResponse>({
    queryKey: ['picklists', kind],
    url: '/picklists',
    axiosConfig: {
      params: { kind },
    },
  })
}

export const useCreatePicklistEntry = () => {
  const queryClient = useQueryClient()
  return useMutation<PicklistEntry, Error, { kind: PicklistKind; label: string }>(
    ['create_picklist'],
    {
      url: '/picklists',
      method: 'POST',
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries({ queryKey: ['picklists', variables.kind] })
      },
    },
  )
}

export const useDeletePicklistEntry = () => {
  const queryClient = useQueryClient()
  return useMutation<{ ok: boolean }, Error, { id: string }>(
    ['delete_picklist'],
    {
      url: `/picklists/:id`,
      method: 'DELETE',
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['picklists'] })
      },
    },
  )
}
